import React from 'react';
import styled from 'styled-components';

import { Container } from '../components/common';
import { CustomerReviews } from '../components/Reviews/CustomerReviews';
import { TestimonialsSlider } from '../components/Reviews/TestimonialsSlider';
import { media } from '../utils/styles';

const Wrap = styled.div`
  padding: 200px 0 150px;
  ${media.phone} {
    padding: 150px 0 100px;
  }
`;

const Header = styled.div`
  margin: 0 0 48px;
  text-align: center;
  ${media.phone} {
    margin: 0 0 40px;
  }
`;

const Heading = styled.h1`
  font-weight: 600;
  font-size: 64px;
  line-height: 77px;
  color: #171616;
  width: 488px;
  max-width: 100%;
  margin: 10px auto 0;
  ${media.phone} {
    margin: 12px auto 0;
    font-size: 40px;
    line-height: 48px;
    color: #000000;
    width: 285px;
  }
`;

const ReviewsPage = ({ pageContext: { content, reviews } }) => {
  return (
    <Wrap>
      <Container>
        <Header>
          <div>
            <svg
              width="142"
              height="27"
              viewBox="0 0 142 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5439 20.25L5.58301 24.4217L7.10341 15.5859L0.662887 9.32827L9.56347 8.03913L13.5439 0L17.5244 8.03913L26.425 9.32827L19.9844 15.5859L21.5048 24.4217L13.5439 20.25Z"
                fill="#DD3072"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42.4385 20.25L34.4775 24.4217L35.9979 15.5859L29.5574 9.32827L38.458 8.03913L42.4385 0L46.4189 8.03913L55.3195 9.32827L48.879 15.5859L50.3994 24.4217L42.4385 20.25Z"
                fill="#DD3072"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M71.3291 20.25L63.3682 24.4217L64.8886 15.5859L58.448 9.32827L67.3486 8.03913L71.3291 0L75.3095 8.03913L84.2101 9.32827L77.7696 15.5859L79.29 24.4217L71.3291 20.25Z"
                fill="#DD3072"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M100.224 20.25L92.2627 24.4217L93.7831 15.5859L87.3426 9.32827L96.2432 8.03913L100.224 0L104.204 8.03913L113.105 9.32827L106.664 15.5859L108.185 24.4217L100.224 20.25Z"
                fill="#DD3072"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M129.119 20.25L121.158 24.4217L122.679 15.5859L116.238 9.32827L125.139 8.03913L129.119 0L133.1 8.03913L142 9.32827L135.56 15.5859L137.08 24.4217L129.119 20.25Z"
                fill="#DD3072"
              />
            </svg>
          </div>
          <Heading>{content.heading}</Heading>
        </Header>
        <TestimonialsSlider testimonials={content.testimonials} />
        <CustomerReviews reviews={reviews} />
      </Container>
    </Wrap>
  );
};

export default ReviewsPage;
